// extracted by mini-css-extract-plugin
module.exports = {"container":"FetchSelect_container__29Mda"};